import { Scene, Camera, RawShaderMaterial, PlaneGeometry, Mesh } from "three";
import Common from "./Common";

export default class ShaderPass{
    constructor(props){
        this.props = props;
        this.uniforms = this.props.material?.uniforms;
        this.common = Common.getInstance();
    }

    init(){
        this.scene = new Scene();
        this.camera = new Camera();

        if(this.uniforms){
            this.material = new RawShaderMaterial(this.props.material);
            this.geometry = new PlaneGeometry(2.0, 2.0);
            this.plane = new Mesh(this.geometry, this.material);
            this.scene.add(this.plane);
        }
    }

    update(){
        this.common.renderer.setRenderTarget(this.props.output);
        this.common.renderer.render(this.scene, this.camera);
        this.common.renderer.setRenderTarget(null);
    }

    destroy() {
        if (this.geometry) {
            this.geometry.dispose();
            this.geometry = null;
        }

        if (this.material) {
            this.material.dispose();
            this.material = null;
        }

        if (this.plane) {
            this.scene.remove(this.plane);
            this.plane = null;
        }

        if (this.scene) {
            while (this.scene.children.length > 0) {
                const child = this.scene.children[0];
                this.scene.remove(child);
                if (child.geometry) child.geometry.dispose();
                if (child.material) child.material.dispose();
            }
            this.scene = null;
        }

        this.camera = null;

        if (this.uniforms) {
            for (let key in this.uniforms) {
                this.uniforms[key].value = null;
            }
            this.uniforms = null;
        }

        this.props = null;

        this.common = null;
    }
}
